import { FirestoreResponse } from "../models/firestore";
import { UserDefaultType, FirestoreUserData } from "../models/user";
import { getOptions_POST, parseResponse } from "./http";

function getBody(user: UserDefaultType, engagementId: string): FirestoreUserData {

    const firestoreData: FirestoreUserData = {
        engagementId: engagementId,
        companyId: user.companyId ,
        firstName: user.firstName,
        lastName: user.lastName,
        userEmail: user.emailId,
        userId: user.userId,
        userType: user.userType,
        locale: user.locale,
        location: user.location,
        phoneNumber: user.phoneNumber
    }
    return firestoreData
}

export default async function firestore(url_firestore:string, user: UserDefaultType, engagementId: string): Promise<FirestoreResponse> {
    try {
        console.debug(`FIRESTORE requested...`);
        const response = await fetch(url_firestore, getOptions_POST( getBody(user, engagementId) ));
        return parseResponse('FIRESTORE', response);
    } catch (error: any) {
        console.error(`Failed to retrieve FIRESTORE data`);
        throw error;
    }
}